import proxy from "api/proxy";
import { getStorage } from "store/local";
import CardItemActivity from "./CardItemActivity.jsx";

const stateColors = {
  overdue: {
    header: "bg-rose-300",
    card: "bg-rose-50",
    textHeader: "!text-rose-900",
  },
  today: {
    header: "bg-neutral-800",
    card: "bg-neutral-50",
    textHeader: "!text-neutral-100",
  },
  tomorrow: {
    header: "bg-sky-300",
    card: "bg-sky-50",
    textHeader: "!text-sky-800",
  },
  thisWeek: {
    header: "bg-amber-300",
    card: "bg-amber-50",
    textHeader: "!text-amber-900",
  },
  nextWeek: {
    header: "bg-lime-300",
    card: "bg-lime-50",
    textHeader: "!text-lime-900",
  },
};

const TYPES_LEADS = [
  { id: "action", name: "Action" },
  { id: "call", name: "Call" },
  { id: "on_site_appointment", name: "On-Site Appointment" },
  { id: "virtual_appointment", name: "Virtual Appointment" },
  { id: "chat", name: "Chat" },
  { id: "email", name: "Email" },
];
function invisibleButton(btn, record) {
  if (!record?.state) return true;
  const state = record.state;
  if (btn === "planned") return true;
  if (btn === "rescheduled") return state !== "planned";
  if (btn === "done") return !["planned", "rescheduled"].includes(state);
  return true;
}

const stateTags = {
  planned: "amber",
  rescheduled: "rose",
  done: "lime",
};

const getAgent = async () => {
  const session = getStorage("ctxSession");
  const dom = [["user", "=", session.user]];
  const fields = ["id", "rec_name"];
  const { data } = await proxy.search("commission.agent", dom, fields, 1);
  return data?.[0];
};

function layout() {
  const ctxView = {
    model: "crm.activity",
    form_action: ["add", "edit"],
    table_action: ["edit"],
    target: "opportunity",
    // availableViews: ["list", "column"],
    display: "modal",
    states: stateColors,
    kanbanStatusField: "state",
    kanbanDateGrouping: true,
    kanbanDateField: "planned_date",
    kanbanTitle: "crm_activities_title",
    kanbanHideTimes: true,
    kanbanHideSearch: true,
    kanbanShowToolbar: false,
    kanbanShowOptions: false,
    kanbanUseModal: false,
    kanbanHorizontal: true,
    kanbanUseHeaderColumn: false,
    kanbanCardComponent: CardItemActivity,
    multi_filter: true,
    title: { field: "number", model: true },
    tags: {
      state: stateTags,
    },
    limit: 50,
    fields: {
      customer: {
        type: "many2one",
        model: "crm.prospect",
        readOnly: true,
      },
      subject: {
        type: "char",
      },
      state: {
        type: "char",
        readOnly: true,
        tags: stateTags,
      },
      description: {
        type: "text",
      },
      planned_time: {
        type: "datetime",
      },
      planned_date: {
        type: "date_2",
        required: true,
        filter: true,
      },
      duration: {
        type: "integer",
      },
      effective_date: {
        type: "date_2",
      },
      type_: {
        type: "selection",
        options: TYPES_LEADS,
        translate: true,
        required: true,
        filter: true,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        default: getAgent,
        searchable: true,
      },
      opportunity: {
        type: "many2one",
        model: "crm.opportunity",
        readOnly: true,
        searchable: true,
        filter: true,
        link: "crm_sales/opportunity",
      },
      planned: {
        type: "button",
        button_method: "planned",
        invisible: invisibleButton,
        color: "sky",
      },
      rescheduled: {
        type: "button",
        button_method: "rescheduled",
        invisible: invisibleButton,
        color: "rose",
      },
      done: {
        type: "button",
        button_method: "done",
        invisible: invisibleButton,
        color: "green",
      },
    },
    list: [
      { name: "customer" },
      { name: "type_", width: "30%" },
      { name: "agent" },
      { name: "subject" },
      { name: "description" },
      { name: "planned_date", width: "30%" },
      { name: "duration", width: "30%" },
      { name: "state", width: "30%", widget: "circle" },
    ],
    form: [
      { name: "customer" },
      {
        name: "block1",
        type: "grid",
        cols: "grid-cols-2",
        colSpan: "col-span-1",
        elements: [{ name: "opportunity" }, { name: "state" }],
      },
      { name: "agent" },
      { name: "subject" },
      { name: "type_" },
      {
        name: "dates",
        type: "grid",
        cols: "grid-cols-3",
        colSpan: "col-span-1",
        elements: [
          { name: "planned_date" },
          { name: "effective_date" },
          { name: "duration" },
        ],
      },
      {
        name: "description",
        type: "grid",
        cols: "grid-cols-1",
        elements: [{ name: "description" }],
      },
      {
        name: "actions",
        type: "grid",
        cols: "grid-cols-5",
        colSpan: "col-span-2",
        elements: [
          { name: "planned" },
          { name: "rescheduled" },
          { name: "done" },
        ],
      },
    ],
  };
  return ctxView;
}
export { layout };
